<template>
  <page>
    <template slot="content">
      <help-content :title="'組織変更によるイベントへの影響について'">
        <template slot="content">
          <div class="text">
            組織変更の内容によって、<b>開催中のイベントに影響する可能性がありますが、終了後のイベントには影響しません</b>。<br>
            イベントへの影響を避けるために、組織変更はできるだけイベント終了後に行うようにしましょう。<br>
            以下は組織変更が開催中のイベントに与える影響を説明します。
          </div>
          <div class="text">
            個人対決イベント：新規参加者のスコアは参加の日からイベントに反映されます。また、<b>組織の変更（部門情報の変更等）はイベントに反映されます</b>。<br>
            参加者がグループから退会した場合、当該参加者のスコアデータが<b>クリアされ、復元できませんので</b>、ご留意ください。
          </div>
          <div class="text">
            チーム対決イベント：新規参加者のスコアは参加の日からイベントに反映されます。ただし、<b>組織の変更（部門情報の変更等）はイベントに反映されません</b>。<br>
            参加者がグループから退会した場合、当該参加者のスコアデータが<b>クリアされ、復元できませんので</b>、ご留意ください。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/HelpAdmin1.vue